import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { formatSignatureSource } from '../../util/pirFormatting'
import { SmallBodyText, BoldSmallBodyText, Subheading } from '../styles/Text'
import { FlexColumn, SpaceBetweenRowContainer, MedBGContainer } from '../styles/Containers'
import { ErrorMessage } from '../common/UserMessage'
import PIRFile from '../files/PIRFile'
import PIRAuthorizationButton from './PIRAuthorizationButton'
import SignatureStatus from './SignatureStatus'
import pirTerminology from '../../util/pirTerminology'

const HeaderContainer = styled(SpaceBetweenRowContainer)`
  @media only screen and (max-width: 1200px) {
    flex-wrap: wrap;
  }
`

const Item = styled(SpaceBetweenRowContainer)`
  align-items: flex-start;
`

const Label = styled(BoldSmallBodyText)`
  width: 40%;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

const Value = styled(SmallBodyText)`
  width: 60%;
  text-wrap: wrap;
  word-break: break-word;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

function PIRAuthorization({ pirId, authorizerRole, signatureSource, status, filename = '', onSuccess = () => {} }) {
  return (
    <FlexColumn gap="15px">
      <HeaderContainer gap="5px">
        <Subheading>{pirTerminology.getAuthorizerHeading(authorizerRole)}</Subheading>
        {!(signatureSource === 'UPLOAD' && status === 'NEW') && <SignatureStatus status={status} />}
      </HeaderContainer>
      <Item gap="5px 15px">
        <Label>Authorization</Label>
        <Value>{formatSignatureSource(signatureSource)}</Value>
      </Item>
      {status === 'COMPLETED' && filename && (
        <MedBGContainer padding="5px 20px 5px 5px">
          <PIRFile file={{ name: filename }} pirId={pirId} buttonAction="download" type="signature" />
        </MedBGContainer>
      )}
      {signatureSource === 'UPLOAD' && status === 'NEW' && <ErrorMessage>An error prevented the file from being uploaded.</ErrorMessage>}
      {signatureSource === 'ELECTRONIC' && ['NEW', 'UPLOADED', 'DRAFT', 'SEND_FAILED'].includes(status) && (
        <ErrorMessage>
          There was an error sending the digital signature. Please reach out to support@vvctec.com or upload a signature file.
        </ErrorMessage>
      )}
      <PIRAuthorizationButton pirId={pirId} authorizerRole={authorizerRole} currentFileName={filename} onSuccess={onSuccess} />
    </FlexColumn>
  )
}

PIRAuthorization.propTypes = {
  pirId: PropTypes.string.isRequired,
  authorizerRole: PropTypes.oneOf(['OWNER', 'STRATA', 'REQUESTOR']).isRequired,
  signatureSource: PropTypes.oneOf(['ELECTRONIC', 'UPLOAD']).isRequired,
  status: PropTypes.oneOf(['SENT', 'NEW', 'COMPLETED', 'UPLOADED', 'DRAFT', 'SEND_FAILED']).isRequired,
  filename: PropTypes.string,
  onSuccess: PropTypes.func
}

export default PIRAuthorization
